import * as React from 'react';

interface Options {
  enabled?: boolean;
  delay?: number;
  preventScroll?: boolean;
}

function useFocusOnMount(
  inputRef: React.RefObject<HTMLInputElement>,
  { enabled = true, delay, preventScroll = true }: Options = {}
) {
  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    if (typeof delay === 'number' && delay > 0) {
      const timeoutId = window.setTimeout(() => {
        inputRef.current?.focus({
          preventScroll,
        });
      }, delay);

      return () => {
        window.clearTimeout(timeoutId);
      };
    }

    inputRef.current?.focus({
      preventScroll,
    });
  }, [inputRef, enabled, delay, preventScroll]);
}

export default useFocusOnMount;
